import { NgModule } from '@angular/core';
import { ChatbotService } from './chatbot.service';
import { DivisaoService } from './divisao.service';
import { EditoraService } from './editora.service';

@NgModule({
  providers: [DivisaoService, EditoraService, ChatbotService]
})
export class ServiceModule { }
